import * as yup from 'yup';
import * as v from 'src/utils/form/validate';

const maxNameLength = 100;
const maxProposalLength = 2000;

export default function getValidationSchema() {
  const validationSchema = yup.object({
    name: v.validateName(yup, "ім'я", maxNameLength, false),
    email: v.validateEmail(yup, false),
    header: v.validateName(yup, 'тема листа', maxNameLength, false),
    description: v.validateName(yup, 'текст', maxProposalLength)
  });

  return validationSchema;
}
